import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource-variable/inter";
import "@fontsource-variable/plus-jakarta-sans";
import "@fontsource-variable/noto-sans-sc";
import "@/index.css";
import "@/lib/pwa";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { GoogleMapsProvider } from "@/lib/gmaps";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* 根级错误边界（2026-10-22）：此前没有兜底，任一组件渲染期抛错都会卸载整棵树，
        用户看到整页白屏且没有任何提示（详见 components/ErrorBoundary.jsx 注释）。 */}
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <GoogleMapsProvider>
          <App />
        </GoogleMapsProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
